import PlayerProfile from "@/pages/player/page";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_pathlessLayout/player/$playerId")({
    validateSearch: z.object({
        teamId: z.coerce.number().optional(),
    }),
    component: PlayerProfile,
});
